import { actionTypes, initialState } from "./countries.constant";

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ON_COUNTRY_DATA: {
      return {
        ...state,
        countries: [...action.payload.data],
        count: action.payload.count,
        total: action.payload.total,
      };
    }
    case actionTypes.ON_COUNTRY_DATA_LOADING: {
      return {
        ...state,
        countryDataLoading: true,
      };
    }
    case actionTypes.ON_COUNTRY_DATA_SUCCESS: {
      return {
        ...state,
        countryDataLoading: false,
      };
    }
    case actionTypes.ON_COUNTRY_DATA_ERROR: {
      return {
        ...state,
        countryDataError: action.payload,
      };
    }
    case actionTypes.ON_COUNTRY_DATA_QUERY: {
      return {
        ...state,
        countryDataError: action.payload,
        countries: action.payload.data,
        count: action.payload.count,
        total: action.payload.total,
      };
    }
    case actionTypes.ON_COUNTRY_POST_LOADING: {
      return {
        ...state,
        postCountryLoading: true,
      };
    }
    case actionTypes.ON_COUNTRY_POST_SUCCESS: {
      return {
        ...state,
        postCountryLoading: false,
      };
    }
    case actionTypes.ON_COUNTRY_DATA_DELETE_LOADING: {
      return {
        ...state,
        deleteCountryLoading: true,
      };
    }
    case actionTypes.ON_COUNTRY_DATA_DELETE_SUCCESS: {
      return {
        ...state,
        deleteCountryLoading: false,
      };
    }

    default:
      return { ...state };
  }
};
